import PropTypes from "prop-types";
import Title from "../atom/Title";
import Select from "../atom/Select";
export default function FormRowSelect({
  title,
  id,
  value,
  inputName,
  changeFun,
  options,
  disabled
}) {
  return (
    <>
      <div className="form-row">
        <Title title={title} />
        <Select
          id={id}
          value={value}
          inputName={inputName}
          changeFun={changeFun}
          options={options}
          disabled={disabled}
        />
      </div>
    </>
  );
}

FormRowSelect.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  changeFun: PropTypes.func,
  classN: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  inputName: PropTypes.string,
  options: PropTypes.array.isRequired,
  disabled : PropTypes.bool
};
